import { useMutation } from '@tanstack/react-query'
import { useApiClientAccount } from '~/@api/client/useApiClientAccount'
import type { IWithdrawFundsRequest } from '~/@api/generated-api-types-account/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useWithdrawFunds() {
  const client = useApiClientAccount()

  const withdrawFundsMutation = useMutation({
    mutationFn: async (props: IWithdrawFundsRequest) => {
      return await client.account
        .walletControllerWithdrawFunds(props, { secure: true })
        .then((res) => res.data)
    },
  })

  return {
    withdrawFunds: withdrawFundsMutation.mutate,
    isRequesting: withdrawFundsMutation.isPending,
    error: getApiErrorMessage(
      withdrawFundsMutation.error,
      'Výber prostriedkov sa nepodaril.'
    ),
    handleReset: withdrawFundsMutation.reset,
  }
}

export { useWithdrawFunds }
